
define('tpl!taoQtiItem/qtiCreator/editor/mathInput/tpl/mathInput', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div class=\"math-input\">\n    <div class=\"math-input-toolbar\"></div>\n    <div class=\"math-input-form\">\n        <span class=\"math-input-mathquill\"></span>\n    </div>\n</div>";
  });
});

